import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=0a45bcab&"
import script from "./nodeWrap.vue?vue&type=script&lang=js&"
export * from "./nodeWrap.vue?vue&type=script&lang=js&"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports